
import './Best.css'




function Best() {
    return (


            <div>

             <div className="container">

              <h3 className='text-light ms-5 mt-5'><b>Best Sellers</b></h3>
              <div className="line ms-5 bg-danger mb-2"></div>

              <div className="row">
                
                <div className="col-6 col-lg-3 col-md-6 col-sm-6">

                  

<div class="card  ">
               <div className="mainbox d-flex gap-3 ">
                  <div className="bbox bg-danger"></div>
                  <div className="bbox bg-danger"></div>
                  <div className="bbox bg-danger"></div>
                  </div>
          <img src="https://www.kfcpakistan.com/images/43a9fb50-ffaa-11ed-8180-812e571998fe-krunch_variant_0-2023-05-31115706.png"   class="card-imgb" alt="..."/>
          <div class="card-img-overlay">
            <h5 class="card-titleb"><b>Krunch Burger</b></h5>
            <p class="card-textb text-end">Rs <b>270</b></p>
            </div>
            </div>
           
                </div>
                <div className="col-6 col-lg-3 col-md-6 col-sm-6">
                <div class="card  ">
                <div className="mainbox d-flex gap-3 ">
                  <div className="bbox bg-danger"></div>
                  <div className="bbox bg-danger"></div>
                  <div className="bbox bg-danger"></div>
                  </div>
          <img src="https://www.kfcpakistan.com/images/43a9fb50-ffaa-11ed-8180-812e571998fe-HotWings_variant_0-2023-05-31115706.png" class="card-imgb" alt="..."/>
          <div class="card-img-overlay">
            <h5 class="card-titleb"><b>Hot Wings Bucket</b></h5>
            <p class="card-textb text-end">Rs <b>610</b></p>
            </div>
            </div>

                </div>
                <div className="col-6 col-lg-3 col-md-6 col-sm-6">

                <div class="card  ">
                  <div className="mainbox d-flex gap-3 ">
                  <div className="bbox bg-danger"></div>
                  <div className="bbox bg-danger"></div>
                  <div className="bbox bg-danger"></div>
                  </div>
          <img src="https://www.kfcpakistan.com/images/33685b40-0461-11ee-911c-497570899609-Mighty_variant_0-2023-06-06115641.png" class="card-imgb" alt="..."/>
          <div class="card-img-overlay">
            <h5 class="card-titleb"><b>Mighty Zinger</b></h5>
            <p class="card-textb text-end">Rs <b>700</b></p>
            </div>
            </div>

                </div>
                <div className="col-6 col-lg-3 col-md-6 col-sm-6">

                  
               <div class="card  ">
                <div className="mainbox d-flex gap-3 ">
                  <div className="bbox bg-danger"></div>
                  <div className="bbox bg-danger"></div>
                  <div className="bbox bg-danger"></div>
                  </div>
          <img src="https://www.kfcpakistan.com/images/43a9fb50-ffaa-11ed-8180-812e571998fe-crunch-with-fries-and-drink-2023-05-31115706.png" class="card-imgb" alt="..."/>
          <div class="card-img-overlay">
            <h5 class="card-titleb"><b>Krunch Combo</b></h5>
            <p class="card-textb ">Rs <b>520</b></p>
            </div>
            </div>

                </div>
              </div>
           


             

              </div>


            </div>

    )
}

export default Best
